import DiceRoller from "./dice-roller";
import vikingNames from "./chatgpt-oracles/viking-names.json";

// Import all Dishonored oracles
import factionGoals from "./dishonored-oracles/faction-goals.json";
import missionHooks from "./dishonored-oracles/mission-hooks.json";
import gadgets from "./dishonored-oracles/gadgets.json";
import indoorEvents from "./dishonored-oracles/indoor-events.json";
import npcs from "./dishonored-oracles/npcs.json";
import dunwallLocations from "./dishonored-oracles/dunwall-locations.json";
import consumables from "./dishonored-oracles/consumables.json";
import roofEvents from "./dishonored-oracles/roof-events.json";
import enemies from "./dishonored-oracles/enemies.json";
import dunwallDistricts from "./dishonored-oracles/dunwall-districts.json";
import npcNames from "./dishonored-oracles/npc-names.json";
import randomEvents from "./dishonored-oracles/random-events.json";
import runesAndCharms from "./dishonored-oracles/runes-and-charms.json";
import npcRumors from "./dishonored-oracles/npc-rumors.json";
import roomDescriptors from "./dishonored-oracles/room-descriptors.json";
import spellsAndPowers from "./dishonored-oracles/spells-and-powers.json";
import factions from "./dishonored-oracles/factions.json";
import weapons from "./dishonored-oracles/weapons.json";
import foundObjects from "./dishonored-oracles/found-objects.json";
import factionEvents from "./dishonored-oracles/faction-events.json";

// Import all Ironsworn oracles
import actions from "./ironsworn-oracles/actions.json";
import challengeRank from "./ironsworn-oracles/challenge-rank.json";
import characterDescriptor from "./ironsworn-oracles/character-descriptor.json";
import characterDisposition from "./ironsworn-oracles/character-disposition.json";
import characterGoal from "./ironsworn-oracles/character-goal.json";
import characterRole from "./ironsworn-oracles/character-role.json";
import combatActions from "./ironsworn-oracles/combat-actions.json";
import coastalWatersLocation from "./ironsworn-oracles/coastal-waters-location.json";
import elfNames from "./ironsworn-oracles/elf-names.json";
import giantNames from "./ironsworn-oracles/giant-names.json";
import ironlanderNames from "./ironsworn-oracles/ironlander-names.json";
import locationDescriptor from "./ironsworn-oracles/location-descriptor.json";
import location from "./ironsworn-oracles/location.json";
import majorPlotTwist from "./ironsworn-oracles/major-plot-twist.json";
import mysticBacklash from "./ironsworn-oracles/mystic-backlash.json";
import npcConversation from "./ironsworn-oracles/npc-conversation.json";
import npcKnowledgeTopic from "./ironsworn-oracles/npc-knowledge-topic.json";
import npcKnowledgeType from "./ironsworn-oracles/npc-knowledge-type.json";
import races from "./ironsworn-oracles/races.json";
import region from "./ironsworn-oracles/region.json";
import settlementNamePrefixes from "./ironsworn-oracles/settlement-name-prefixes.json";
import settlementNameSuffixes from "./ironsworn-oracles/settlement-name-suffixes.json";
import settlementNames from "./ironsworn-oracles/settlement-names.json";
import settlementTrouble from "./ironsworn-oracles/settlement-trouble.json";
import theme from "./ironsworn-oracles/theme.json";
import trollNames from "./ironsworn-oracles/troll-names.json";
import varouNames from "./ironsworn-oracles/varou-names.json";

// Import all Starforged oracles
import storyClue from "./starforged-oracles/story-clue.json";
import storyComplication from "./starforged-oracles/story-complication.json";

// Import all Delve oracles
import abilities from "./delve-oracles/abilities.json";
import aspect from "./delve-oracles/aspect.json";
import burgeoningConflict from "./delve-oracles/burgeoning-conflict.json";
import category from "./delve-oracles/category.json";
import characteristics from "./delve-oracles/characteristics.json";
import component from "./delve-oracles/component.json";
import cursedSite from "./delve-oracles/cursed-site.json";
import delveDenizenTags from "./delve-oracles/delve-denizen-tags.json";
import delveDescriptor from "./delve-oracles/delve-descriptor.json";
import delveDetail from "./delve-oracles/delve-detail.json";
import delveDomain from "./delve-oracles/delve-domain.json";
import delveOpportunity from "./delve-oracles/delve-opportunity.json";
import delvePlaceBarrowType from "./delve-oracles/delve-place,-barrow-type.json";
import delvePlaceCavernType from "./delve-oracles/delve-place,-cavern-type.json";
import delvePlaceFrozenCavernType from "./delve-oracles/delve-place,-frozen-cavern-type.json";
import delvePlaceIceReachType from "./delve-oracles/delve-place,-ice-reach-type.json";
import delvePlaceMineType from "./delve-oracles/delve-place,-mine-type.json";
import delvePlacePassType from "./delve-oracles/delve-place,-pass-type.json";
import delvePlaceRuinType from "./delve-oracles/delve-place,-ruin-type.json";
import delvePlaceSeaCaveType from "./delve-oracles/delve-place,-sea-cave-type.json";
import delvePlaceShadowfenType from "./delve-oracles/delve-place,-shadowfen-type.json";
import delvePlaceStrongholdType from "./delve-oracles/delve-place,-stronghold-type.json";
import delvePlaceTanglewoodType from "./delve-oracles/delve-place,-tanglewood-type.json";
import delvePlaceUnderkeepType from "./delve-oracles/delve-place,-underkeep-type.json";
import delveTheme from "./delve-oracles/delve-theme.json";
import environmentalCalamity from "./delve-oracles/environmental-calamity.json";
import event from "./delve-oracles/event.json";
import focus from "./delve-oracles/focus.json";
import malignantPlague from "./delve-oracles/malignant-plague.json";
import method from "./delve-oracles/method.json";
import powerHungryMystic from "./delve-oracles/power-hungry-mystic.json";
import primaryForm from "./delve-oracles/primary-form.json";
import rampagingCreature from "./delve-oracles/rampaging-creature.json";
import ravagingHorde from "./delve-oracles/ravaging-horde.json";
import schemingLeader from "./delve-oracles/scheming-leader.json";
import size from "./delve-oracles/size.json";
import target from "./delve-oracles/target.json";
import zealousCult from "./delve-oracles/zealous-cult.json";

type PromptItem =
  | string
  | { roll: string; name: string; description: string };

type OracleTable = {
  title: string;
  theme: string;
  source: string;
  core: boolean;
  prompts: PromptItem[];
  d6?: boolean;
  d66?: boolean;
};

class Oracles {
  newOracleTableTheme = "";
  newOracleTableName = "";
  selectedOracleTable = "";
  selectedOracleSource = "";
  selectedOracleTheme = "";
  editOracleList = "";
  editOracleCursorPosition = 0;
  rollHistory: { Theme: string; Table: string; Result: string }[] = [];
    tables: OracleTable[] = [
    vikingNames,
    factionGoals,
    missionHooks,
    gadgets,
    indoorEvents,
    npcs,
    dunwallLocations,
    consumables,
    roofEvents,
    enemies,
    dunwallDistricts,
    npcNames,
    randomEvents,
    runesAndCharms,
    npcRumors,
    roomDescriptors,
    spellsAndPowers,
    factions,
    weapons,
    foundObjects,
    factionEvents,
    // Add all Ironsworn oracles
    actions,
    challengeRank,
    characterDescriptor,
    characterDisposition,
    characterGoal,
    characterRole,
    combatActions,
    coastalWatersLocation,
    elfNames,
    giantNames,
    ironlanderNames,
    locationDescriptor,
    location,
    majorPlotTwist,
    mysticBacklash,
    npcConversation,
    npcKnowledgeTopic,
    npcKnowledgeType,
    races,
    region,
    settlementNamePrefixes,
    settlementNameSuffixes,
    settlementNames,
    settlementTrouble,
    theme,
    trollNames,
    varouNames,
    // Add all Starforged oracles
    storyClue,
    storyComplication,
    // Add all Delve oracles
    abilities,
    aspect,
    burgeoningConflict,
    category,
    characteristics,
    component,
    cursedSite,
    delveDenizenTags,
    delveDescriptor,
    delveDetail,
    delveDomain,
    delveOpportunity,
    delvePlaceBarrowType,
    delvePlaceCavernType,
    delvePlaceFrozenCavernType,
    delvePlaceIceReachType,
    delvePlaceMineType,
    delvePlacePassType,
    delvePlaceRuinType,
    delvePlaceSeaCaveType,
    delvePlaceShadowfenType,
    delvePlaceStrongholdType,
    delvePlaceTanglewoodType,
    delvePlaceUnderkeepType,
    delveTheme,
    environmentalCalamity,
    event,
    focus,
    malignantPlague,
    method,
    powerHungryMystic,
    primaryForm,
    rampagingCreature,
    ravagingHorde,
    schemingLeader,
    size,
    target,
    zealousCult
  ];
  diceRoller: DiceRoller;

  constructor(state: any) {
    this.diceRoller = new DiceRoller();
    if (!state) return;
    this.editOracleList = state.editOracleList;
    this.newOracleTableName = state.newOracleTableName;
    this.tables = state.tables;
    this.rollHistory = state.rollHistory ?? [];
    this.selectedOracleSource = state.selectedOracleSource;
    this.selectedOracleTheme = state.selectedOracleTheme;
    this.selectedOracleTable = state.selectedOracleTable;
  }

  titleCase(str: string) {
    str = str.toLowerCase();
    const parts = str.split(" ");
    for (var i = 0; i < parts.length; i++) {
      parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
    }
    return parts.join(" ");
  }

  isCore(table: string) {
    let oracleTable = this.tables.find((o) => o.title === table);
    return oracleTable?.core;
  }

  getRandomPromptFromOracleTable(table: string) {
    let oracle = this.tables.find((o) => o.title === table);
    if (!oracle) return "";
    let rn = this.diceRoller.roll([oracle.prompts.length]);
    let promptItem = oracle.prompts[rn[0].value];
    this.addRollHistory(oracle.theme, oracle.title, promptItem);
    return promptItem;
  }

  getPromptItemValue(item: PromptItem) {
    if (typeof item === "string") return item;
    return item.name;
  }

  addRollHistory(theme: string, table: string, result: PromptItem) {
    this.rollHistory.unshift({ Theme: theme, Table: table, Result: this.getPromptItemValue(result) });
    if (this.rollHistory.length > 15)
      this.rollHistory = this.rollHistory.slice(0, 14);
  }

  getOracleTablePrompts(table: string) {
    let out = "";
    let oracleTable = this.tables.find((o) => o.title === table);
    if (!oracleTable) return;

    oracleTable.prompts.map((p) => (out += p + "\n"));
    out.replace(/^\s+|\s+$/g, "");
    return out;
  }

  getOracleTableAsArray(table: string) {
    if (table === "Select Table") return;
    let t = this.tables.find((o) => o.title === table)?.prompts;
    return t;
  }

  getDelveSiteName(domain: string) {
    let out = "";
    let rn = this.diceRoller.roll([7])[0].value;
    let descriptor = this.titleCase(
      this.getPromptItemValue(this.getRandomPromptFromOracleTable("Delve Descriptor"))
    );
    let detail = this.titleCase(
      this.getPromptItemValue(this.getRandomPromptFromOracleTable("Delve Detail"))
    );
    let place = this.titleCase(
      this.getPromptItemValue(this.getRandomPromptFromOracleTable(`Delve Place, ${domain} Type`))
    );
    let namesake = this.getPromptItemValue(this.getRandomPromptFromOracleTable("Ironlander Names"));
    switch (rn) {
      case 0:
        out += `the ${descriptor} ${place}`;
        break;
      case 1:
        out += `the ${place} of ${descriptor}`;
        break;
      case 2:
        out += `the ${place} of ${descriptor} ${detail}`;
        break;
      case 3:
        out += `the ${place} of ${namesake}'s ${detail}`;
        break;
      case 4:
        out += `${namesake}'s ${place}`;
        break;
      case 5:
        out += `the ${descriptor} ${place} of ${namesake}`;
        break;
      case 6:
        out += `the ${place} of ${namesake}`;
        break;
    }
    return out;
  }

  getNPCName(race: string) {
    return this.getRandomPromptFromOracleTable(`${race} Names`);
  }

  get Action() {
    return this.getRandomPromptFromOracleTable("Actions");
  }

  get Theme() {
    return this.getRandomPromptFromOracleTable("Theme");
  }

  get Region() {
    return this.getRandomPromptFromOracleTable("Region");
  }

  get Location() {
    return this.getRandomPromptFromOracleTable("Location");
  }

  get CoastalWatersLocation() {
    return this.getRandomPromptFromOracleTable("Coastal Waters Location");
  }

  get LocationDescriptor() {
    return this.getRandomPromptFromOracleTable("Location Descriptor");
  }

  get LocationTrouble() {
    return this.getRandomPromptFromOracleTable("Settlement Trouble");
  }

  get SettlementName() {
    if (parseInt(this.diceRoller.roll([2])[0].value) - 1) {
      return this.getRandomPromptFromOracleTable("Settlement Names");
    } else {
      let prefix = this.getRandomPromptFromOracleTable(
        "Settlement Name Prefixes"
      );
      let suffix = this.getRandomPromptFromOracleTable(
        "Settlement Name Suffixes"
      );
      return this.getPromptItemValue(prefix) + this.getPromptItemValue(suffix).toLowerCase();
    }
  }

  get IronlanderName() {
    return this.getRandomPromptFromOracleTable("Ironlander Names");
  }

  get CharacterRole() {
    return this.getRandomPromptFromOracleTable("Character Role");
  }

  get CharacterGoal() {
    return this.getRandomPromptFromOracleTable("Character Goal");
  }

  get CharacterDescriptor() {
    return this.getRandomPromptFromOracleTable("Character Descriptor");
  }

  get CharacterDisposition() {
    return this.getRandomPromptFromOracleTable("Character Disposition");
  }

  get NPCRace() {
    return this.getRandomPromptFromOracleTable("Races");
  }

  get NPCConversation() {
    return this.getRandomPromptFromOracleTable("NPC Conversation");
  }

  get NPCKnowledge() {
    let prefix = this.getRandomPromptFromOracleTable("NPC Knowledge Type");
    let suffix = this.getRandomPromptFromOracleTable("NPC Knowledge Topic");
    return prefix + " " + suffix;
  }

  get PrimaryStat() {
    return this.diceRoller.roll([5], true)[0].value;
  }

  get DelveOpportunity() {
    return this.getRandomPromptFromOracleTable("Delve Opportunity");
  }

  getOracleTableSources() {
    let tn: string[] = [];
    this.tables.map((o) => {
      if (!tn.includes(o.source)) tn.push(o.source);
      return undefined;
    });
    return tn;
  }

  getOracleTableThemes(source: string) {
    let tn: string[] = [];
    this.tables
      .filter((t) => t.source.match(source))
      .map((o) => {
        if (!tn.includes(o.theme)) tn.push(o.theme);
        return undefined;
      });
    return tn;
  }

  getOracleTableNames(source: string, theme: string) {
    let tn: string[] = [];
    this.tables
      .filter((t) => t.source.match(source) && t.theme.match(theme))
      .map((o) => tn.push(o.title));
    return tn;
  }

  get DelveTheme() {
    return this.getRandomPromptFromOracleTable("Delve Theme");
  }

  get DelveDomain() {
    return this.getRandomPromptFromOracleTable("Delve Domain");
  }
}

export default Oracles;
